import { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Link, useNavigate } from "react-router-dom";
import { AuthService } from "../../services/authService";
import { Toast } from "primereact/toast";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

const EmailResetForm = () => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toastRef = useRef<Toast>(null);
  const [isSuccess, setIsSuccess] = useState(false);


  const emailValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Email is not valid") 
      .required("Email is required"),
  });
  

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: emailValidationSchema,
   onSubmit: async (values) => {
  setSubmitting(true);
  setIsSuccess(false);
  try {
    const result = await AuthService.sendEmailResetPassword(values.email);
    if (result && result.statusCode === 2000) {
      setIsSuccess(true);
        toastRef.current?.show({
            severity: "success",
            summary: "Success",
            detail: result.message,
            life: 3000,
        });
        navigate("/auth/resend-email", { state: { email: values.email } });
    } else {
        toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: result.message,
            life: 3000,
        });
    }
} catch (error: any) {
    const errorMessage = error.response?.data?.message || "An error occurred while processing the request.";
    toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 3000,
    });
} finally {
    setSubmitting(false);
}
},

  });

  return (
    <div className="login flex flex-col items-center w-full ">
       <div className=" icon-container flex justify-center items-center">
      <Toast ref={toastRef} className="toast-top-center" />
        </div>
      <div className="flex flex-col items-center mt-5">
        <h4 className="text-xl mb-1 font-bold">Forgot your password ?</h4>
        <p className="mb-6 text-slate-500 text-sm">
          Enter email associated with your account and we'll send 
          <br />and email with instructions to reset your password.
        </p>
      </div>
      <form onSubmit={formik.handleSubmit} className="w-full flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full md:w-3/4">
          <div className="field flex flex-col w-full mb-2 col-span-2 mx-auto">
            <FloatLabel>
              <InputText
                id="email"
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                className={`w-full p-2 border rounded-md ${formik.errors.email && formik.touched.email ? "p-invalid border-red-500" : "border-gray-300"}`}
                placeholder=" "
              />
              <label htmlFor="email">Email *</label>
            </FloatLabel>
            {formik.errors.email && formik.touched.email && (
              <Message
                severity="error"
                text={formik.errors.email}
                className="input-message"
              />
            )}
          </div>
          <div className="field flex flex-col w-full mb-2 col-span-2 mx-auto">
            <Button
              label="Confirm"
              type="submit"
              loading={submitting}
              className="w-full col-span-2 p-2 font-bold text-xl rounded bg-primary-500 text-white hover:bg-orange-600"
              disabled={submitting || !formik.isValid || isSuccess}
            />
          </div>
        </div>
      </form>
      <div className="mt-4 text-center text-sm">
        <p className="mb-0">
          Go to login page ?{" "}
          <Link to={"/auth"} className="text-primary-600 fw-semibold">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default EmailResetForm;
